import * as React from "react";
const SvgFloorPlan = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" style={{
  enableBackground: "new 0 0 100 100"
}} viewBox="0 0 100 100" width="1em" height="1em" {...props}><path d="M0 0v100h24.6v-8.1H8V66h36.1V39.8h-8v18.1H8V8.1h28.1v15h8v-15H92v38H60.8v29.1h8v-21H92v37.7H43.7v8.1H100V0z" style={{
    fill: "#333"
  }} /></svg>;
export default SvgFloorPlan;